import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      d="M13.2153 2.97488C13.0212 2.78621 12.7123 2.78621 12.5182 2.97488L10.7182 4.72488C10.5202 4.91737 10.5158 5.23392 10.7083 5.43191C10.9007 5.62991 11.2173 5.63436 11.4153 5.44187L12.3667 4.51684V11.4832L11.4153 10.5582C11.2173 10.3657 10.9007 10.3702 10.7083 10.5682C10.5158 10.7662 10.5202 11.0827 10.7182 11.2752L12.5182 13.0252C12.7123 13.2139 13.0212 13.2139 13.2153 13.0252L15.0153 11.2752C15.2133 11.0827 15.2177 10.7662 15.0252 10.5682C14.8328 10.3702 14.5162 10.3657 14.3182 10.5582L13.3667 11.4832V4.51684L14.3182 5.44187C14.5162 5.63436 14.8328 5.62991 15.0252 5.43191C15.2177 5.23392 15.2133 4.91737 15.0153 4.72488L13.2153 2.97488Z"
      fill="currentColor"
    />
    <path
      d="M2.66675 4.00004C2.39061 4.00004 2.16675 4.2239 2.16675 4.50004C2.16675 4.77618 2.39061 5.00004 2.66675 5.00004H5.06675C5.34289 5.00004 5.56675 4.77618 5.56675 4.50004C5.56675 4.2239 5.34289 4.00004 5.06675 4.00004H2.66675Z"
      fill="currentColor"
    />
    <path
      d="M2.66675 6.33337C2.39061 6.33337 2.16675 6.55723 2.16675 6.83337C2.16675 7.10952 2.39061 7.33337 2.66675 7.33337H6.26675C6.54289 7.33337 6.76675 7.10952 6.76675 6.83337C6.76675 6.55723 6.54289 6.33337 6.26675 6.33337H2.66675Z"
      fill="currentColor"
    />
    <path
      d="M2.66675 8.66671C2.39061 8.66671 2.16675 8.89056 2.16675 9.16671C2.16675 9.44285 2.39061 9.66671 2.66675 9.66671H7.46675C7.74289 9.66671 7.96675 9.44285 7.96675 9.16671C7.96675 8.89056 7.74289 8.66671 7.46675 8.66671H2.66675Z"
      fill="currentColor"
    />
    <path
      d="M2.66675 11C2.39061 11 2.16675 11.2239 2.16675 11.5C2.16675 11.7762 2.39061 12 2.66675 12H8.66675C8.94289 12 9.16675 11.7762 9.16675 11.5C9.16675 11.2239 8.94289 11 8.66675 11H2.66675Z"
      fill="currentColor"
    />
  </SvgIcon>
));
